<template>
  <KimbapBody />
</template>

<script>
import KimbapBody from '../molecules/KimbapBody.vue'


export default {
  name: 'KimbapView',
  components: {
    KimbapBody,
  }
}
</script>
